export default __webpack_public_path__ + "static/media/gca.29192264.svg";